import React, { useEffect, useState } from "react";
import api, { formatDate } from "../lib/api";
import { ArrowDownRight, ArrowUpRight, Repeat } from "lucide-react";

const TYPE_META = {
  giris: {
    label: "Giriş",
    icon: ArrowUpRight,
    class: "text-emerald-700 bg-emerald-50 border-emerald-200",
  },
  cikis: {
    label: "Çıkış",
    icon: ArrowDownRight,
    class: "text-red-700 bg-red-50 border-red-200",
  },
  duzeltme: {
    label: "Düzeltme",
    icon: Repeat,
    class: "text-amber-700 bg-amber-50 border-amber-200",
  },
};

export default function Movements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/movements")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="movements-root">
      <div className="mb-6">
        <div className="font-mono-code text-[10px] tracking-[0.3em] text-stone-500">
          KAYIT DEFTERİ
        </div>
        <h1 className="font-serif-display text-3xl sm:text-4xl text-stone-900">
          Stok Hareketleri
        </h1>
        <p className="text-sm text-stone-500 mt-1">
          Tüm giriş, çıkış ve düzeltme kayıtları burada listelenir.
        </p>
      </div>

      <div className="card-lux overflow-hidden">
        <table className="min-w-full">
          <thead className="bg-stone-50 border-b border-stone-200">
            <tr className="text-xs uppercase tracking-wider text-stone-500">
              <th className="px-4 py-3 text-left">Tarih & Saat</th>
              <th className="px-4 py-3 text-left">Ürün</th>
              <th className="px-4 py-3 text-left">Kod</th>
              <th className="px-4 py-3 text-left">İşlem</th>
              <th className="px-4 py-3 text-right">Miktar</th>
              <th className="px-4 py-3 text-left">Açıklama</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-stone-100">
            {loading && (
              <tr>
                <td colSpan={6} className="text-center py-10 text-stone-400">
                  Yükleniyor...
                </td>
              </tr>
            )}
            {!loading && items.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center py-14 text-stone-500">
                  Henüz stok hareketi kaydedilmemiş.
                </td>
              </tr>
            )}
            {items.map((m) => {
              const meta = TYPE_META[m.type] || TYPE_META.giris;
              const Icon = meta.icon;
              return (
                <tr key={m.id} data-testid={`movement-${m.id}`}>
                  <td className="px-4 py-3 text-sm text-stone-600 font-mono-code">
                    {formatDate(m.created_at)}
                  </td>
                  <td className="px-4 py-3 text-sm text-stone-900 font-medium">
                    {m.product_name}
                  </td>
                  <td className="px-4 py-3 text-xs text-stone-600 font-mono-code">
                    {m.sku}
                  </td>
                  <td className="px-4 py-3">
                    <span
                      className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full border font-medium ${meta.class}`}
                    >
                      <Icon className="w-3 h-3" /> {meta.label}
                    </span>
                  </td>
                  <td
                    className={`px-4 py-3 text-right text-sm font-mono-code font-semibold ${
                      m.amount >= 0 ? "text-emerald-700" : "text-red-700"
                    }`}
                  >
                    {m.amount > 0 ? "+" : ""}
                    {m.amount}
                  </td>
                  <td className="px-4 py-3 text-sm text-stone-600 max-w-[280px] truncate">
                    {m.note}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
